import {
  getReferenceDataById,
  getReferenceDataByValue,
} from '../../functions/get-reference-data-by-id';
import { IReferenceData } from '../../interfaces/form/reference-data.model';

export interface IStudentProfileData {
  firstName?: string;
  middleName?: string;
  lastName?: string;
  dateOfBirth?: string;
  gender?: number;
  homeLanguage?: number;
  hispanicFlag?: string;
  phoneNumber?: string;
  email?: string;
  homeDistrict?: string;
  ethnicityCode?: string;
  studentAddress?: {
    streetNumber?: string;
    streetName?: string;
    apartmentNo?: string;
    borough?: number;
    state?: number;
    city?: string;
    zipCode?: string;
  };
}

export interface IStudentProfileReferenceData {
  sex?: IReferenceData[];
  language?: IReferenceData[];
  borough?: IReferenceData[];
  state?: IReferenceData[];
  district?: IReferenceData[];
  ethnicity?: IReferenceData[];
}

export class StudentProfileResponseModel {
  firstName: string;
  middleName: string;
  lastName: string;
  dateOfBirth: Date;
  age: number;
  gender: IReferenceData;
  ethnicity: IReferenceData[] = [];
  homeLanguage: IReferenceData;
  borough: IReferenceData;
  city: string;
  state: IReferenceData;
  zip: string;
  apartmentNo: string;
  district: IReferenceData;
  hispanicFlag: string;
  streetNumber: string;
  streetName: string;
  phoneNumber: string;
  email: string;

  constructor(data: Partial<IStudentProfileData>, refernceData: IStudentProfileReferenceData) {
    //Basic Information
    this.firstName = data?.firstName;
    this.middleName = data?.middleName;
    this.lastName = data?.lastName;
    this.dateOfBirth = data?.dateOfBirth
      ? new Date(data.dateOfBirth)
      : undefined;

    // Identity
    this.gender = getReferenceDataById(data?.gender, refernceData?.sex);
    this.homeLanguage = getReferenceDataById(
      data?.homeLanguage,
      refernceData?.language
    );
    this.hispanicFlag = data?.hispanicFlag;

    // Communication Information
    this.phoneNumber = data?.phoneNumber;
    this.email = data?.email;

    // Housing Information
    this.streetNumber = data?.studentAddress?.streetNumber;
    this.streetName = data?.studentAddress?.streetName?.trim()?.toUpperCase();
    this.apartmentNo = data?.studentAddress?.apartmentNo?.trim();
    this.borough = getReferenceDataById(
      data?.studentAddress?.borough,
      refernceData?.borough
    );
    this.state = getReferenceDataById(
      data?.studentAddress?.state,
      refernceData?.state
    );
    this.district = getReferenceDataByValue(
      data?.homeDistrict,
      refernceData?.district
    );
    this.city = data?.studentAddress?.city?.trim();
    this.zip = data?.studentAddress?.zipCode?.trim();

    // Ethnicity can be either be an empty string, one value or multiple values, stored in a comma separated string
    // If empty string, do not display anything in textbox
    if (data?.ethnicityCode) {
      const ethnicityCodes: string[] = data?.ethnicityCode.split(',');
      ethnicityCodes.forEach((code: string) => {
        this.ethnicity.push(
          getReferenceDataByValue(code, refernceData.ethnicity)
        );
      });
    }
  }
  readonly id: string = '';
}
